// The review form's rules and what it sends. Port of v1's reviewFormSchema
// (zod; its messages verbatim) and ReviewPageShell's submit
// (apps/widget/src/components/ReviewForm, ReviewPageShell).

export type ReviewFormValues = {
  firstName: string;
  lastName: string;
  showOnlyFirstName: boolean;
  /** 0–5 stars; 0 is none picked. */
  rating: number;
  opinion: string;
};

export type ReviewFormErrors = Partial<Record<keyof ReviewFormValues, string>>;

export const emptyReview = (firstName = ""): ReviewFormValues => ({
  firstName,
  lastName: "",
  showOnlyFirstName: false,
  rating: 0,
  opinion: "",
});

export function validateReview(v: ReviewFormValues): ReviewFormErrors {
  const errors: ReviewFormErrors = {};
  if (!v.firstName.trim()) errors.firstName = "First name is a required field";
  if (v.rating < 1) errors.rating = "How many stars would you rate it?";
  const opinion = v.opinion.trim();
  if (!opinion) errors.opinion = "Please say something about your experience";
  else if (opinion.length < 5) errors.opinion = "Your review has to be at least 5 characters long.";
  return errors;
}

/** POST /widget/bookings/:id/review's body. The API keeps ratings out of
 * 10 and the stars go to 5; it splits `name` into first and last itself. */
export function reviewPayload(v: ReviewFormValues) {
  return {
    name: [v.firstName.trim(), v.lastName.trim()].filter(Boolean).join(" "),
    value: v.rating * 2,
    text: v.opinion.trim(),
    showOnlyFirstName: v.showOnlyFirstName,
  };
}

/** The star picker's keyboard: arrows step, a digit 0–5 jumps; null for any
 * other key. Clicking the current star clears it (see `clickStar`). */
export function ratingForKey(key: string, current: number): number | null {
  if (key === "ArrowRight" || key === "ArrowUp") return Math.min(current + 1, 5);
  if (key === "ArrowLeft" || key === "ArrowDown") return Math.max(current - 1, 0);
  if (/^[0-5]$/.test(key)) return Number(key);
  return null;
}

export const clickStar = (star: number, current: number) => (star === current ? 0 : star);
